/* eslint-disable @typescript-eslint/naming-convention */
import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserSessionService } from '../../util/user-session.service';
import { APP_CONFIG } from '../../../../environments/app_config';

@Injectable({providedIn: 'root'})
export class ApiRequestInterceptor implements HttpInterceptor {
    urlsToExclude: string[] = [];

    constructor(private userSessionService: UserSessionService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const authReq = req.clone({ headers: this.getAuthorizationHeader(req.url) });
        return next.handle(authReq);
    }

    getAuthorizationHeader(url: string): HttpHeaders {
        const defaultHeaders = {
            'Content-Type': 'application/json',
            'Ocp-Apim-Trace': 'true',
            'Ocp-Apim-Subscription-Key': APP_CONFIG.ENVIRONMENT.API_DETAILS.SUBSCRIPTION_KEY,
        };

        const userInfo = this.userSessionService.getCurrentUser();
        let headers = {};
        if (userInfo && userInfo.userKey && !this.urlsToExclude.includes(url)) {
            headers = {
                ...defaultHeaders,
                Authorization: `Basic ${userInfo.userKey}`,
            };
        } else {
            headers = {
                ...defaultHeaders,
            };
        }
        return new HttpHeaders(headers);
    }
}
